import React, { Component, useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import Loader from '../Loader/Loader';
import Helper from '../Helper'
import useStateRef from 'react-usestateref';
import { useRef } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { APPLICATION_JSON } from '../../middleware/types';
import { useSelector, useDispatch } from 'react-redux';
import { updateShoppingListDetailsAction } from '../../middleware/updateShoppingListDetailsAction';
import './Modal.css'

export const Modal = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError, setHasErrorRef] = useStateRef(false);
    const [errorMessage, setErrorMessage, errorMessageRef] = useStateRef();
    const [giftId, setGiftId, giftIdRef] = useStateRef(props && props.giftId ? props.giftId : "");
    const [addListToCartResponse, setAddListResponse, addListToCartRef] = useStateRef(props && props.props);
    const [giftlistId, setGiftlistId, giftlistIdRef] = useStateRef(props && props.giftlistId ? props.giftlistId : "");
    const [addShoppingListResponse, setAddShoppingListResponse, addShoppingListResponseRef] = useStateRef("")
    const history = useHistory();
    const dispatch = useDispatch();
    const copyListErrorRef = useRef(null);
    // const formRef = useRef(null);

    const index = props.index;

    useEffect(() => {
        console.log("modalUseeffect modal");
        setGiftlistId(props.giftlistId);
    }, [props.giftlistId])

    console.log("props.giftlistId", props.giftlistId);
    //validate copy list form
    const ValidateCopyListForm = (key, value) => {
        switch (key) {
            case "listName":
                var validation = /[!#$%"&|{}~`]/;
                var regex = RegExp(validation);
                var result = Helper.isEmpty(value)
                if (result) {
                    setHasError(true)
                    copyListErrorRef.current.classList.remove("d-none")
                    copyListErrorRef.current.classList.add("d-block")
                    // document.getElementById("eventName").classList.add("form-error")
                    copyListErrorRef.current.innerHTML = "List Name is a required field. Special characters cannot be used.";
                } else if (regex.test(value)) {
                    setHasError(true)
                    copyListErrorRef.current.classList.remove("d-none")
                    copyListErrorRef.current.classList.add("d-block")
                    // document.getElementById("eventName").classList.add("form-error")
                    copyListErrorRef.current.innerHTML = "List Name should not contain special characters.";
                } else {
                    copyListErrorRef.current.innerHTML = "";
                    copyListErrorRef.current.classList.remove("d-block")
                    copyListErrorRef.current.classList.add("d-none")
                    // document.getElementById("eventName").classList.remove("form-error")
                }
                break;

            default:
        }
    }

    const handleCopyList = (event) => {
        event.preventDefault();
        // setIsLoading(true)
        setHasError(false)
        var index = event.currentTarget.getAttribute('index')
        var formData = new FormData(event.target);
        var giftId = event.currentTarget.getAttribute('giftId')


        var searchParam = window.location.search
        var giftlistId = searchParam.split("=")
        var eventName = formData.get("listName")
        var description = formData.get("listDescription")
        var copy = "true"

        const formValue = Object.fromEntries(formData.entries());
        Object.entries(formValue).map(([key, value], keyIndex) => {
            ValidateCopyListForm(key, value)
        })

        if (!setHasErrorRef.current) {
            const inputMap = {
                giftlistId: giftId ? giftId : giftlistId && giftlistId[1] ? giftlistId[1] : "",
                eventName: eventName,
                description: description,
                copy: copy
            }
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/shopping-list-details/copy-list`, {
                credentials: "include",
                method: "POST",
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(inputMap)
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        document.getElementById(`copy-list-close${index}`).click()
                        copyListErrorRef.current.classList.remove("d-none");
                        setIsLoading(false)
                        history.push(res.response)
                    } else {
                        setIsLoading(false)
                        const error = res.errorMessage;
                        // setErrorMessage(error);
                        copyListErrorRef.current.classList.remove("d-none");
                        copyListErrorRef.current.classList.add("d-block");
                        copyListErrorRef.current.innerHTML = error;
                    }
                })
        }

    }
    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(false)
        setHasError(false)
        var actionUrl = event.target.getAttribute('action');
        var searchParam = window.location.search;
        let params = new URLSearchParams(searchParam);
        let id = params.get("giftlistId");
        var formData = new FormData(event.target);
        formData.append("giftlistId", id)
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/${actionUrl}`, {
            credentials: "include",
            method: "POST",
            enctype: "multipart/form-data",
            body: formData
        }).then(res => res.json())
            .then(res => {
                console.log("res", res);

                if (res.result == "success") {
                    var shoppingListSuccessDetatils = res.response;
                    setAddShoppingListResponse(shoppingListSuccessDetatils);
                    dispatch(updateShoppingListDetailsAction(true));
                    // formRef.current.reset();
                    document.getElementById("closeImportListModal").click();
                    props.handleSuceesModalTrigger(true)

                    // console.log("setAddShoppingListResponse", addShoppingListResponseRef.current);
                    // var currentUrl = window.location.pathname.concat(window.location.search);
                    // console.log("before concat",currentUrl);
                    // currentUrl = currentUrl.concat("&added=true")
                    // console.log("after concat",currentUrl);
                    // history.push(currentUrl)
                    
                  
                } else {
                    console.log("error", res.result);

                }
            })
    }

    async function handleSubmitEmailList(event) {
        event.preventDefault();
        setIsLoading(false)
        setHasError(false)
        var index = event.currentTarget.getAttribute('index')
        var actionUrl = event.target.getAttribute('action');
        var formId = event.target.id;
        Helper.clearErrorMsg(formId);
        const validateEmailListForm = (key, value) => {
            switch (key) {
                case "emailList":
                    var validation = "^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\\.)+[A-Za-z]{2,6}(,|$)";
                    var regex = RegExp(validation);
                    var result = Helper.isEmpty(value.trim())
                    if (result) {
                        setHasError(true)
                        document.getElementById(`share-list-error-div${index}`).classList.remove("d-none")
                        document.getElementById(`share-list-error-div${index}`).classList.add("d-block")
                        var emptyEmail = document.getElementById(`share-list-error${index}`)
                        emptyEmail.innerHTML = "Your passwords do not match.";
                    } else if (!regex.test(value.trim())) {
                        setHasError(true)
                        document.getElementById(`share-list-error-div${index}`).classList.remove("d-none")
                        document.getElementById(`share-list-error-div${index}`).classList.add("d-block")
                        var inValidEmail = document.getElementById(`share-list-error${index}`)
                        inValidEmail.innerHTML = "The email address does not appear to be valid. Please use the format name@domain.xxx.";
                    } else {
                        var emptyFirstName = document.getElementById(`share-list-error${index}`)
                        emptyFirstName.innerHTML = "";
                        var emptyFirstNameDiv = document.getElementById(`share-list-error-div${index}`)
                        emptyFirstNameDiv.innerHTML = "";
                    }
                    break;

                default:
            }
        }
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());
        Object.entries(formValue).map(([key, value], keyIndex) => {
            validateEmailListForm(key, value)
        })
        var emailList = formData.get("emailList")
        var message = formData.get("message")
        var giftlistId = event.currentTarget.getAttribute('giftId')
        const inputMap = {
            emailList: emailList,
            giftlistId: giftlistId,
            message: message
        }

        if (!setHasErrorRef.current) {
            // setIsLoading(true)
            var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/${actionUrl}`
            var response = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))
            if (response.result === "success") {
                document.getElementById(`email-list-close${index}`).click()
                setIsLoading(false)
                history.push("/account/list");
            } else {
                console.log("error inside")
            }
        }
    }

    const handleCreateShoppingList = (event) => {
        event.preventDefault();
        var formData = new FormData(event.target);
        var listName = formData.get("listName");
        var listDescription = formData.get("listDescription");

        const inputMap = {
            eventName: listName,
            description: listDescription
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/shopping-list/create`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(inputMap)
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    document.getElementById("new-list-error").innerHTML = "";
                    document.getElementById("new-list-error").classList.add("d-none");
                    document.getElementById("newListClose").click()
                    setIsLoading(false)
                    dispatch(updateShoppingListDetailsAction(true));
                    history.push((JSON.parse(res.response)).response)

                } else {
                    setIsLoading(false)
                    const error = JSON.parse(res.response).errorMessage
                    document.getElementById("new-list-error").innerHTML = error[0].message;
                    document.getElementById("new-list-error").classList.remove("d-none");
                    document.getElementById("new-list-error").classList.add("d-block")
                }
            })
    }
    const handleModalClose = (event) => {
        console.log("modal-index", event)
        document.getElementById(`AddToCartClose${event}`).click()
    }
    const handleGoToCart = (event) => {
        console.log("modal-index", event)
        document.getElementById(`AddToCartClose${event}`).click()
        history.push("/checkout/cart")
    }
    const handleClose = () => {
        document.getElementById("copyList").reset()
        copyListErrorRef.current.innerHTML = "";
        copyListErrorRef.current.classList.remove("d-block");
        copyListErrorRef.current.classList.add("d-none");
    }
    const handleNewListClose = () => {
        document.getElementById("find-friend").reset()
        document.getElementById("new-list-error").innerHTML = "";
        document.getElementById("new-list-error").classList.remove("d-block");
        document.getElementById("new-list-error").classList.add("d-none");
        document.getElementById("newListClose").click()
    }
    return (
        <>
            <div className="modal gx-0 fade c-modal shop-new-list-modal" id={props.newListModalId} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-md">
                    <div className="modal-content">
                        <button type="button" id="newListClose" className="btn-close" data-bs-dismiss="modal" onClick={handleNewListClose} aria-label="Close"></button>
                        <div className="modal-body">
                            <div className='container-fluid list-modal-body'>
                                <div className='row'>
                                    <div className="col-12">
                                        <h3 className="modal-title" id="defaultModalLabel">
                                            New Shopping List
                                        </h3>
                                        <p>
                                            Please enter a name and description for your shopping list.
                                        </p>
                                    </div>
                                    <div class="alert alert-danger d-none" role="alert" id="new-list-error"></div>
                                    <form onSubmit={handleCreateShoppingList} method="post" action="/" id="find-friend" className="col-12 form" data-hs-cf-bound="true">
                                        {/* <div className="container-fluid list-modal-body"> */}
                                            {/* <div className="row"> */}

                                                <div className="row mb-3 align-items-center">
                                                    <label for="eventName" className="col-12 col-md-3 col-form-label">List Name:</label>
                                                    <div className="col-12 col-md-7 c-shopping-modal-input-mobile">
                                                        <input maxlength="25" name="listName" type="text" className="form-control" />
                                                    </div>
                                                </div>

                                                <div class="row mb-3">
                                                    <label for="newDescription" class="col-12 col-md-3 col-form-label">
                                                        List Description:
                                                    </label>

                                                    <div class="col-12 col-md-7 c-shopping-modal-input-mobile">
                                                        <textarea maxlength="120" name="listDescription" class="form-control form-control-text-area"></textarea>
                                                    </div>
                                                </div>
                                                <div className="row justify-content-end form-submit">
                                                    <div className="col-auto">
                                                        <input type="submit" className="col-auto btn btn-primary" value="Create List" />
                                                    </div>
                                                </div>
                                            {/* </div> */}
                                        {/* </div> */}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {props && props.giftlistId ?
                <div className="modal gx-0 fade c-shopping-list-modal-body c-modal" id={`emailModal${index}`} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-md">
                        <div className="modal-content">
                            <button type="button" id={`email-list-close${index}`} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div className="modal-body">
                                <form method="post" action="email-gift-list" id="email-gift-list" giftId={props && props.giftlistId} index={index} onSubmit={handleSubmitEmailList} className="col-12 form" >
                                    <div className="container-fluid list-modal-body">
                                        <div className="row">
                                            <div className="col-12">
                                                <h3 className="modal-title" id="defaultModalLabel">
                                                    Email Shopping List
                                                </h3>
                                            </div>
                                            <div className="col-12 d-none alert alert-danger" id={`share-list-error-div${index}`}>
                                                <div id={`share-list-error${index}`} className=""></div>
                                            </div>

                                            <div className="row">
                                                <label for="eventName" className="col-12 col-md-3 col-form-label">Email(s): *</label>
                                                <div className="col-12 col-md-7 c-shopping-modal-input-mobile">
                                                    <input maxlength="256" name="emailList" type="text" className="form-control" id='emailIput' />
                                                    <p id="email-lists-help" className="form-text">
                                                        Separate multiple addresses with commas.
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="row mb-3">
                                                <label for="notes" className="col-12 col-md-3 col-form-label">
                                                    Notes:
                                                </label>

                                                <div className="col-12 col-md-7 c-shopping-modal-input-mobile">
                                                    <textarea maxlength="120" name="message" className="form-control form-control-text-area" id='notesTextArea'></textarea>
                                                    <div id="giftlistId_error" style={{ color: "red" }}></div>
                                                </div>
                                            </div>
                                            <div className="row justify-content-end form-submit">
                                                <div className="col-auto">
                                                    <button type="submit" className="col-auto btn btn-primary" id="email-list-button">Email List</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                : ""}

            {/* Copy List modal */}
            {props && props.giftlistId ?
                <div className="modal gx-0 fade c-shopping-list-modal-body c-modal" id={`copyListModal${index}`} tabindex="-1" aria-labelledby="copyListModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-md">
                        <div className="modal-content">
                            <button type="button" id={`copy-list-close${index}`} className="btn-close" data-bs-dismiss="modal" onClick={handleClose} aria-label="Close"></button>
                            <div className="modal-body">
                            <div className="container-fluid list-modal-body">
                                        <div className="row">
                                            <div className="col-12">
                                                <h3 className="modal-title" id="defaultModalLabel">
                                                    New Shopping List
                                                </h3>
                                                <p>
                                                    Please enter a name and description for your shopping list.
                                                </p>
                                            </div>

                                            {/* <div id="copy-list-error-message-div" role="alert" className="alert alert-danger col-10 d-none">{errorMessageRef.current ? errorMessageRef.current : ""}</div> */}
                                            <div className="col-12">
                                               <div id="copy-list-error-message-div" role="alert" className="alert alert-danger col-12 d-none" ref={copyListErrorRef}></div>
                                            </div>
                                              <form method="post" action="/copyShoppingList" id="copyList" className="col-12 form" data-hs-cf-bound="true" index={index} giftId={props.giftlistId} onSubmit={handleCopyList}>
                        

                                            <div className="row mb-3 align-items-center">
                                                <label for="eventName" className="col-12 col-md-3 col-form-label">List Name:</label>
                                                <div className="col-12 col-md-7">
                                                    <input maxlength="256" name="listName" id='eventName' type="text" className="form-control" />
                                                </div>
                                            </div>

                                            <div class="row mb-3">
                                                <label for="newDescription" class="col-12 col-md-3 col-form-label">
                                                    List Description:
                                                </label>

                                                <div class="col-12 col-md-7">
                                                    <textarea maxlength="120" name="listDescription" class="form-control form-control-text-area"></textarea>
                                                </div>
                                            </div>
                                            <div className="row justify-content-end form-submit">
                                                <div className="col-auto create-list-div">
                                                    <input type="submit" className="col-auto btn create-submit btn-primary" value="Create List" />
                                                </div>
                                            </div>
                                        </form>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : ""}
            {/* Add List to cart Modal content */}
            {props && props.giftlistId ?
                <div className="modal fade c-modal show" id={`addProductToCartModal${index}`} tabindex="-1" aria-labelledby="addProductToCartModal" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                        <div className="modal-content">
                            <button type="button" id={`AddToCartClose${index}`} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div className="modal-body custom-modal-body">
                            <div class="container-fluid cart-modal">
                                <div class="row">
                                    <div className="col-12 col-lg-6">
                                        <div className="row align-items-center cart-modal">
                                            <div className="col-auto">
                                                <h5 className="modal-title" id="defaultModalLabel">Added to Cart</h5>
                                            </div>

                                            <div className="col-12 col-md-auto order-3 order-lg-2 px-lg-0">
                                                <Link role="button" className="btn-primary" data-bs-dismiss="modal" onClick={() => handleModalClose(index)}>Continue Shopping</Link>
                                                <Link role="button" className="btn-primary" onClick={() => handleGoToCart(index)}>Go to Cart</Link>
                                            </div>
                            
                                            <ul className="col-12 order-2 order-lg-3 cart-added-items list-unstyled">
                                                {props && props.props && props.props.map((value, key) => {
                                                    return (
                                                        <>
                                                            <li className="row g-0 list-cart-modal">
                                                                <div className="col-auto mx-2 added-item-label">
                                                                    <span className="fwb d-block">Item # {value.ProductId}</span>
                                                                    <span className="fwb-qty">Qty: {value.Quantity}</span>
                                                                </div>
                                                                <div className="col-display-name mx-2 col added-item-content">
                                                                    <span dangerouslySetInnerHTML={{ __html:value.productName}}></span>
                                                                </div>
                                                            </li>
                                                        </>
                                                    )
                                                })}
                                            </ul>
                                            {/* invalid product list */}
                                            {props && props.invalidProduct && props.invalidProduct.length > 0 &&
                                                <>
                                                    <ul className='col-12 order-2 order-lg-3 mb-0'>
                                                        <div className='alert alert-danger mb-0 d-block'>
                                                            <p className='mb-0' style={{color:"#333"}}>
                                                                <strong>
                                                                    We were unable to add the following items to your cart:
                                                                </strong>
                                                            </p>
                                                        </div>
                                                    </ul>

                                                    <ul className="col-12 order-2 order-lg-3 cart-added-items list-unstyled">
                                                        {props && props.invalidProduct && props.invalidProduct.map((value, key) => {
                                                            return (
                                                                <>
                                                                    <li className="row g-0 list-cart-modal">
                                                                        <div className="col-auto mx-2 added-item-label">
                                                                            <span className="fwb d-block">Item # {value.ProductId}</span>
                                                                            <span className="fwb-qty">Qty: {value.Quantity}</span>
                                                                        </div>
                                                                        <div className="col-display-name mx-2 col added-item-content">
                                                                            <span  dangerouslySetInnerHTML={{ __html: value.productName }}></span>
                                                                        </div>
                                                                        <div class="col-auto mx-2 added-item-content">
                                                                        <p class="mb-0" style={{color: "red",fontSize:"12px"}} dangerouslySetInnerHTML={{ __html: value.doNotAddToCartMessage}}></p>
                                                                        </div>
                                                                    </li>
                                                                </>
                                                            )
                                                        })}
                                                    </ul>
                                                </>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 cust-recommend d-none d-md-block">
                                        <div className="cart-container-right">
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : ""}

           
            <p id="modal-open-button" className='d-none'></p>
        </>
    )
}
